<template>
  <div class="container-fluid">
    <div class="m-2">
      <div class="alert alert-primary">
        <div class="h4 text-center">
          <linkto :link="'/products'"/>
          Új termék rögzítés
        </div>
      </div>
    </div>
  	<div class="row d-flex justify-content-center">
  		<div class="col-12">
  			<div class="row d-flex justify-content-center align-items-center">
  				<productdata
  					:change="false"
  				>
  				</productdata>
  			</div>
  		</div>
  	</div>
  </div>
</template>

<script>
import productdata from './product_data'
export default {
  name: 'new_product',
  components: {
  	productdata
  }
  
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/products/new_product.vue